import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { authHeader, baseUrl } from '../../../utils';
import axios from 'axios';
import { ERROR } from '../../../store/types';
import Loader from '../../elements/Loader';
import moment from 'moment';
import InvoiceStatus from '../../elements/InvoiceStatus';
import ArrowIcon from '../../elements/icons/ArrowIcon';
import InlinePreloader from '../../elements/InlinePreloader';
import ChevronIcon from '../../elements/icons/ChevronIcon';
import NumberField from '../../elements/form/NumberField';

const AssignedInvoice = ({invoiceId, assignment, closeFunction, openConirmation}) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true);
    const [invoiceDetails, setInvoiceDetails] = useState(null);
    // const invoicesSelector = useSelector(state => state.invoices)
    const [userWallet, setUserWallet] = useState(null)

    useEffect(() => {
      const fetchUserWallet = async () => {
        try {
          const headers = authHeader()
          const response = await axios.get(`${baseUrl}/user-wallets`, {headers})
          setUserWallet(response.data.data)

          setLoading(false)
          // setUserWallet({})
        } catch (error) {
          console.log('fetch user wallet error: ', error.response)
          setLoading(false)
          // dispatch({
          //   type: ERROR,
          //   error
          // })
        }
      }

      const fetchInvoice = async () => {
        try {
          const headers = authHeader()
  
            const response = await axios.get(`${baseUrl}/invoices/${invoiceId}?expand=fees.fee`, { headers })            
  
            setInvoiceDetails(response.data.data)
            fetchUserWallet()
            
          } catch (error) {
              console.log(error)
              dispatch({
                  type: ERROR,
                  error
              })
              setLoading(false)
          }
      }
  
      fetchInvoice()
  
  
      return () => {
        
      };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const [processing, setProcessing] = useState(false);

    const initializePayment = async () => {
      setValidationErrors({})
      try {
        if(assignment.partPayments?.confirmed) {

          if(!amount || amount < 1) {
            setValidationErrors({amount: true})
            return
          }
          
          const invoiceBalance = (assignment.discountedTotal - (assignment.amountPaid || 0))/100

          if(amount && (invoiceBalance > assignment.partPayments.minimumAmount && amount < assignment.partPayments.minimumAmount)) {
            setValidationErrors({amount: true})
            dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: `Minimum payable amount is N${assignment.partPayments.minimumAmount.toLocaleString()}`
              }}}
            })
            return
          }

          if(amount && (invoiceBalance < assignment.partPayments.minimumAmount && amount < invoiceBalance)) {
            setValidationErrors({amount: true})
            dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: `Minimum payable amount is N${invoiceBalance.toLocaleString()}`
              }}}
            })
            return
          }

          if(amount && (amount > invoiceBalance)) {
            setValidationErrors({amount: true})
            dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: `Amount chosen is greater than invoice balance N${invoiceBalance.toLocaleString()}`
              }}}
            })
            return
          }
        }

        const headers = authHeader()

        const paymentPayload = {
            invoiceAssignment: assignment._id,
            paymentChannel: "ONLINE",
            student: assignment.student,
            parent: assignment.parent,
            amount: assignment.partPayments ? amount * 100 : undefined,
            redirectUrl: `${window.location.origin}/user/verify-payment?invoice-assignment=${assignment._id}&student=${assignment.student._id}`
        }
        setProcessing(true)
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/payments/initialize-payment`, paymentPayload, { headers })           
        console.log(response.data)
        window.location.href = response.data.data.link

        setLoading(false)
      } catch (error) {
          console.log(error)
          setProcessing(false)
          dispatch({
              type: ERROR,
              error
          })
          setLoading(false)
      }
    }

    const [choosingAmount, setChoosingAmount] = useState(false)
    const [validationErrors, setValidationErrors] = useState({})
    const [amount, setAmount] = useState(null)

    const [processingFromWallet, setProcessingFromWallet] = useState(false)

    const initializePaymentFromWallet = async () => {
      const invoiceBalance = (assignment.discountedTotal - (assignment.amountPaid || 0))/100
      setValidationErrors({})
      try {
        if(assignment.partPayments?.confirmed) {

          if(!amount || amount < 1) {
            setValidationErrors({amount: true})
            return
          }
          

          if(amount && (invoiceBalance > assignment.partPayments.minimumAmount && amount < assignment.partPayments.minimumAmount)) {
            setValidationErrors({amount: true})
            dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: `Minimum payable amount is N${assignment.partPayments.minimumAmount.toLocaleString()}`
              }}}
            })
            return
          }

          if(amount && (invoiceBalance < assignment.partPayments.minimumAmount && amount < invoiceBalance)) {
            setValidationErrors({amount: true})
            dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: `Minimum payable amount is N${invoiceBalance.toLocaleString()}`
              }}}
            })
            return
          }

          if(amount && (amount > invoiceBalance)) {
            setValidationErrors({amount: true})
            dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: `Amount chosen is greater than invoice balance N${invoiceBalance.toLocaleString()}`
              }}}
            })
            return
          }
        }

        const headers = authHeader()

        const paymentPayload = {
            invoiceAssignment: assignment._id,
            paymentChannel: "WALLET",
            student: assignment.student,
            parent: assignment.parent,
            amount: assignment.partPayments ? amount * 100 : undefined,
            // redirectUrl: `${window.location.origin}/user/verify-payment?invoice-assignment=${assignment._id}&student=${assignment.student._id}`
        }
        setProcessingFromWallet(true)
        await axios.post(`${process.env.REACT_APP_BASE_URL}/payments/initialize-from-wallet`, paymentPayload, { headers })           

        setProcessingFromWallet(false)
        openConirmation({
          amount: assignment?.partPayments?.confirmed ? amount * 100 : invoiceBalance * 100,
          invoiceCode: assignment.invoiceCode,
          invoiceName: invoiceDetails.name
        })
      } catch (error) {
          console.log(error)
          setProcessingFromWallet(false)
          dispatch({
              type: ERROR,
              error
          })
      }
    }

    return (
      <div className='w-full'>
        {loading ? 
          <div className='w-full'>
            <Loader />
          </div>
  
          :
  
          <>
            <div className='py-3 mb-2'>
              <div className="w-full mx-auto">
                  <div className='w-full xl:flex items-start justify-between'>
                      <div className='w-full xl:w-1/2'>
                          <h4 className='font-medium text-lg text-gray-400'>Invoice Details</h4>
                          <div className=''>
                              <p className='text-gray-500 mt-1 text-sm'>
                                  Below are the details of the invoice.
                              </p>
                          </div>
                      </div>
                      {!assignment.partPayments?.confirmed && <div className='w-full xl:w-1/2'>
                          {assignment.status !== 'PAID_IN_FULL' && 
                          <div className='xl:flex items-center justify-between gap-x-2'>
                            <button onClick={()=>{initializePayment()}} disabled={processingFromWallet || processing} className='p-4 xl:p-3 w-full bg-vcm-purple border border-vcm-purple text-purple-100 rounded-md mt-5 text-sm flex flex-row items-center justify-center gap-x-3 hover:text-white hover:bg-purple-500 transition duration-200 disabled:cursor-not-allowed'>
                              {!processing ? <>
                                  Pay with card/transfer <ArrowIcon className={`w-4 h-4`} />
                              </> : 
                                  <InlinePreloader />
                              }
                            </button>
                            {userWallet && (userWallet.balance.available * 100 > assignment.discountedTotal) && <button onClick={()=>{initializePaymentFromWallet()}}  disabled={processingFromWallet || processing} className='p-4 xl:p-3 mt-2 w-full bg-vcm-light-purple border border-vcm-purple text-vcm-purple rounded-md xl:mt-5 text-sm flex flex-row items-center justify-center gap-x-3 hover:text-vcm-purple hover:bg-purple-400 transition duration-200 disabled:cursor-not-allowed'>
                              {!processingFromWallet ? <>
                                  Pay from Wallet <ArrowIcon className={`w-4 h-4`} />
                              </> : 
                                  <InlinePreloader />
                              }
                            </button>}
                          </div>}
                      </div>}

                      {assignment.partPayments?.confirmed && assignment.status !== 'PAID_IN_FULL' && <div className='w-1/2'>
                          <div className='w-full bg-vcm-light-purple bg-opacity-20 rounded-[8px] py-[15px] px-[20px] transition duration-200'>
                            <div onClick={()=>{setChoosingAmount(!choosingAmount)}} className='cursor-pointer w-full flex items-center justify-between'>
                              <p className='font-space-grotesk font-medium text-sm text-vcm-purple'>Click here to make a payment</p>
                              <ChevronIcon className={`w-4 h-4 text-vcm-purple transition duration-200 ${choosingAmount ? 'rotate-[270deg]' : 'rotate-[180deg]'}`} />
                            </div>
                            {choosingAmount && <div className='w-full'>

                              <div className='w-full my-[10px]'>
                                <NumberField
                                  inputType="number" 
                                  fieldId={`days`}
                                  inputLabel="Please enter the amount you want to pay now" 
                                  inputPlaceholder={`Amount to pay`}
                                  requiredField={true}
                                  preloadValue={''}
                                  bgColor={'bg-[#eddcff]'}
                                  hasError={validationErrors.amount} 
                                  returnFieldValue={(value)=>{setAmount(value)}}
                                />
                              </div>
                              <div className='w-full flex items-center justify-between gap-x-[10px]'>
                                <button onClick={()=>{initializePayment()}} className='p-4 xl:p-2 w-full bg-vcm-purple border border-vcm-purple text-purple-100 rounded-md mt-5 text-sm flex flex-row items-center justify-center gap-x-3 hover:text-vcm-purple hover:bg-vcm-light-purple transition duration-200'>
                                  {!processing ? <>
                                     Pay with card/transfer
                                  </> : 
                                      <InlinePreloader />
                                  }
                                </button>
                                {userWallet && (userWallet.balance.available * 100 > assignment.discountedTotal) && <button onClick={()=>{initializePaymentFromWallet()}}  disabled={processingFromWallet || processing} className='p-4 xl:p-2 mt-2 w-full bg-vcm-light-purple border border-vcm-purple text-vcm-purple rounded-md xl:mt-5 text-sm flex flex-row items-center justify-center gap-x-3 hover:text-vcm-purple hover:bg-purple-400 transition duration-200 disabled:cursor-not-allowed'>
                                {!processingFromWallet ? <>
                                    Pay from Wallet 
                                </> : 
                                    <InlinePreloader />
                                }
                              </button>}
                              </div>
                            
                            </div>}
                          </div>
                          
                      </div>}
                  </div>
              </div>
            </div>
  
            
              <div className='w-full'>
                <div className='flex items-start justify-between'>
                  <div className='w-full mb-[10px]'>
                    <p className='text-xs text-gray-400 mb-[5px]'>Name</p>
                    <h3 className='font-[500] text-black text-lg'>{invoiceDetails.name}</h3>
  
                    <div className='mt-[20px]'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Description</p>
                      <p className='font-[500] text-sm text-black'>{invoiceDetails.description}</p>
                    </div>

                    <div className='w-full mt-[20px] mb-[10px]'>
                      <div className='w-full flex items-center gap-x-[20px]'>
                        <div className='w-full'>
                          <p className='text-xs text-gray-400 mb-[5px]'>Invoice Total</p>
                          <h3 className={`font-[600] text-black ${assignment.partPayments?.confirmed && assignment.status === 'PART_PAID' ? 'text-gray-500 text-3xl' : 'text-black text-4xl'}`}>₦{(assignment.discountedTotal/100).toLocaleString()}</h3>
                        </div>
                        {assignment.partPayments?.confirmed && assignment.status === 'PART_PAID' && <div className='w-full'>
                          <p className='text-xs text-gray-400 mb-[5px]'>Balance</p>
                          <h3 className='font-[600] text-black text-3xl'>₦{((assignment.discountedTotal - assignment.amountPaid)/100).toLocaleString()}</h3>
                        </div>}
                      </div>

                      {assignment.discount?.confirmed && <p className='p-[10px] bg-green-500 bg-opacity-5 w-[80%] rounded mt-[10px] text-green-800 text-xs'><span className='font-space-grotesk font-[500] text-sm'>Discount applied</span><br/>{assignment.discount.description}</p>}

                      {assignment.partPayments?.confirmed && <p className='p-[10px] bg-blue-500 bg-opacity-5 w-[80%] rounded mt-[10px] text-blue-800 text-xs'><span className='font-space-grotesk font-[500] text-sm'>Part payments allowed</span><br/><span className='inline-block mt-[5px]'>{assignment.partPayments?.description}</span><br />
                      Max Installments: <span className='font-[550]'>{assignment.partPayments?.totalPayments}</span><br />
                      Minimum Amount: <span className='font-[550]'>₦{assignment.partPayments?.minimumAmount?.toLocaleString()}</span>
                      </p>}

                      {assignment.sundry?.transactions?.length > 0 && <p className='text-sm text-gray-500 mt-[10px]'>This invoice amount includes sundry transactions totalling <span className='font-[600] font-space-grotesk text-lg text-black'>₦{(assignment.sundry.total/100).toLocaleString()}</span> from <span className='text-black font-[600]'>{moment(assignment.sundry.dateFrom).format('LL')} to {moment(assignment.sundry.dateTo).format('LL')}</span></p>}
                  </div>
                  </div>
                  <div className='w-full mb-[10px]'>
                    <div className=''>
                      <p className='text-xs text-gray-400 mb-[5px]'>Invoice Code</p>
                      <p className='font-[500] text-xl font-space-grotesk text-black'>{invoiceDetails.invoiceCode}</p>
                    </div>
                    <div className='mt-[20px]'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Payment Status</p>
                      {/* <p className='font-[500] text-xl font-space-grotesk text-black'>{invoiceDetails.invoiceCode}</p> */}
                      <InvoiceStatus status={assignment.status} />

                    </div>

                     <div className='mt-[20px]'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Payment Date</p>
                      {assignment.paymentDate && assignment.paymentDate !== null ? <p className='text-sm'>{moment(assignment.paymentDate).format('LL')} - {moment(assignment.paymentDate).format('hh:mm a')}</p> : <div className='h-[15px] w-[150px] bg-gray-100 animate-pulse' />}
                    </div>

                    <div className='mt-[20px]'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Payment Deadline</p>
                      <p className='text-sm'>{moment(assignment.paymentDeadline).format('LL')}</p>
                    </div>
                    
                    {/* <div className='mt-[10px]'>
                      <p className='text-xs text-gray-400 mb-[5px]'>Description</p>
                      <p className='font-[500] text-sm text-black'>{invoiceDetails.description}</p>
                    </div> */}
                  </div>
                </div>
  
                <div className='w-full pt-[20px] border-t mt-[20px]'>
                  <div className='w-full mb-[10px]'>
                    <h3 className='text-gray-600 mb-[5px] font-[550]'>Fees (all fees that make up this invoice)</h3>
  
                    <div className='w-full mt-[20px] flex items-center justify-between mb-[10px] p-[5px] bg-gray-100'>
                      <div className='w-6/12'>
                        <p className='text-xs text-gray-400 mb-[5px]'>Fee</p>
                      </div>
                      <div className='w-3/12'>
                        <p className='text-xs text-gray-400 mb-[5px] text-right'>Rate</p>
                      </div>
                      <div className='w-1/12'>
                        <p className='text-xs text-gray-400 mb-[5px] text-right'>Quantity</p>
                      </div>
                      <div className='w-2/12'>
                        <p className='text-xs text-gray-400 mb-[5px] text-right'>Subtotal</p>
                      </div>
                    </div>
                    {invoiceDetails.fees.map((fee, feeIndex)=>(<div key={feeIndex} className='w-full mt-[20px] flex items-start justify-between p-[5px] gap-x-[10px] border-b'>
                      <div className='w-6/12'>
                        <p className='text-gray-700 mb-[5px]'>{fee.fee.name}</p>
                        <p className='text-gray-500 text-sm mb-[5px]'>{fee.fee.description}</p>
                      </div>
                      <div className='w-3/12'>
                        <p className='text-gray-700 font-space-grotesk font-[500] mb-[5px] text-right'>{(fee.fee.amount/100).toLocaleString()}</p>
                      </div>
                      <div className='w-1/12'>
                        <p className='text-gray-700 mb-[5px] text-right'>{fee.quantity}</p>
                      </div>
                      <div className='w-2/12'>
                        <p className='text-gray-700 font-space-grotesk font-[500] mb-[5px] text-right'>₦{((fee.fee.amount/100) * fee.quantity).toLocaleString()}</p>
                      </div>
                    </div>))}
                  </div>
                </div>

                {assignment.sundry?.transactions?.length > 0 && <div className='w-full p-[20px] bg-gray-50 rounded-[8px] mt-[40px]'>
                  <div className='w-full mb-[10px]'>
                    <h3 className='text-gray-600 mb-[5px] font-[550]'>Sundry Transactions in this invoice</h3>
  
                    <div className='w-full mt-[20px] flex items-center justify-between mb-[10px] p-[5px] bg-gray-100'>
                      <div className='w-6/12'>
                        <p className='text-xs text-gray-400 mb-[5px]'>Reference</p>
                      </div>
                      <div className='w-3/12'>
                        <p className='text-xs text-gray-400 mb-[5px]'>Date</p>
                      </div>
                      <div className='w-1/12'>
                        <p className='text-xs text-gray-400 mb-[5px]'>Items</p>
                      </div>
                      <div className='w-2/12'>
                        <p className='text-xs text-gray-400 mb-[5px] text-right'>Amount</p>
                      </div>
                    </div>
                    {assignment.sundry?.transactions?.map((transaction, transactionIndex)=>(<div key={transactionIndex} className='w-full mt-[20px] flex items-start justify-between p-[5px] gap-x-[10px] border-b'>
                      <div className='w-6/12'>
                        <p className='text-gray-700 font-space-grotesk mb-[5px]'>{transaction.reference}</p>
                        {/* <p className='text-gray-500 text-sm mb-[5px]'>{fee.fee.description}</p> */}
                      </div>
                      <div className='w-3/12'>
                        <p className='text-gray-700 font-[500] mb-[5px] text-sm'>{moment(transaction.createdAt).format('MMMM Do YYYY, h:mm a')}</p>
                      </div>
                      <div className='w-1/12'>
                        <p className='text-gray-700 mb-[5px] text-sm'>{transaction.items.length} item(s)</p>
                      </div>
                      <div className='w-2/12 text-right'>
                        <p className='text-gray-700 font-space-grotesk font-[500] mb-[5px]'>₦{(transaction.amount/100).toLocaleString()}</p>
                      </div>
                    </div>))}
                  </div>
                </div>}
              </div>
          </>
  
        }

        <div className="mt-8 flex flex-row-reverse gap-x-4">
            <button
                type="button"
                className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                onClick={closeFunction}
            >
                Close
            </button>
            
        </div>
      </div>
    )
  }
export default AssignedInvoice